import React from 'react';
import { Badge, BadgeProps } from 'pounceV2';

const NotificationJewelV3 = ({
  content,
  variant = 'primary-solid' as BadgeProps['variant'],
  ...rest
}) => {
  return (
    <Badge
      borderRadius="circle"
      alignSelf="center"
      border="none"
      size="small"
      fontWeight="medium"
      cursor="default"
      variant={variant}
      {...rest}
    >
      {content}
    </Badge>
  );
};

export default React.memo(NotificationJewelV3);
